import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-5 py-5 sm:py-8 items-center justify-center bg-[#0A0A0A]" data-id="element-119">
      {/* Badge */}
      <div className="mb-3" data-id="element-120">
        <span className="bg-[#d4af37]/10 text-[#d4af37] text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide border border-[#d4af37]/20" data-id="element-121">
          🏏 The #1 Planning System for Cricket Coaches
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-4xl text-3xl sm:text-5xl md:text-6xl leading-[1.1] mb-3 tracking-tight" data-id="element-122">
        Plan Your Entire Cricket Season{' '}
        <span className="text-[#d4af37]" data-id="element-123">In Under 5 Minutes.</span>
      </h1>

      {/* Subheadline */}
      <p className="text-[#B0B0C0] text-sm sm:text-base max-w-2xl mx-auto mb-3 font-medium leading-relaxed" data-id="element-124">
        The complete cricket coaching bible — 50 full sessions, 60+ drills,
        annual planning, batting, bowling, fielding progressions, tactics and
        more. Everything done for you.
      </p>

      {/* Bullets — compact */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-4 max-w-2xl" data-id="element-125">
        {['1 Main Volume', '5 Bonuses', '50+ Sessions', '60+ Drills', 'U8 to U18'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-126">
            <span className="text-[#d4af37] text-sm" data-id="element-127">✅</span>
            <span className="text-white text-xs sm:text-sm font-semibold" data-id="element-128">
              {item}
            </span>
          </div>)}
      </div>

      {/* Mockup image — smaller */}
      <div className="relative w-full max-w-[200px] sm:max-w-[300px] mx-auto mb-4" data-id="element-129">
        <img src="https://cdn.magicpatterns.com/uploads/6sfC8QKvJKEUtrZTAsKXjD/ChatGPT_Image_22_jun_2026,_13_01_52-Photoroom.png" alt="CRICKET READY™ — The Complete Kit" className="w-full h-auto object-contain drop-shadow-2xl" width={800} height={800} fetchPriority="high" data-id="element-130" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-10 bg-[#d4af37] opacity-20 rounded-full pointer-events-none" style={{
        filter: 'blur(40px)'
      }} data-id="element-131" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-cta-green font-black text-base sm:text-xl px-6 sm:px-10 py-3.5 sm:py-4 rounded-2xl transition-colors inline-block mb-3 w-full sm:w-auto max-w-md shadow-xl !bg-[#22c55e] !text-white" data-id="element-132">
        🚀 I WANT CRICKET READY NOW
      </a>

      {/* Trust badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-[#B0B0C0] text-[11px] sm:text-sm font-medium" data-id="element-133">
        <span className="flex items-center gap-1.5" data-id="element-134">🔒 Secure Payment</span>
        <span className="flex items-center gap-1.5" data-id="element-135">⚡ Instant Access</span>
        <span className="flex items-center gap-1.5" data-id="element-136">🛡️ 7-Day Guarantee</span>
      </div>
    </section>;
}